export interface IFiltroTransacoesViewModel {
    guid?: string;
    codigoFrota?: number;
    DataDe?: string;
    DataAte?: string;
    CodAcesso: number;
    CodTipoEntidade: number;
    DscSituacao?: string ;
}

export interface IFiltroRegistroTransacoesViewModel {
    guid?: string;
    rowsppage?: number; // Numero max de retornos do objeto
    dscPlaca?: string;
    codPosto?: number;
    codSubFrota?: number;
    codFrota?: number;
    codVeiculo?: number;
    codMotorista?: number;
    status?: string;
    datIniPeriodo?: string; // Data inicio da consulta. padrao (hoje - 1 mes)
    datFimPeriodo?: string; // Data fim. padrao data atual do dia
}
